/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState, useCallback } from 'react';

import { Link } from 'react-router-dom';
import { FiEdit } from 'react-icons/fi';
import { AiOutlineFileAdd } from 'react-icons/ai';
import { useToast } from '../../../../context/ToastContext';

import {
  Container,
  Content,
  ContainerInfoDrawing,
  InfoDrawing,
} from './styles';
import api from '../../../../services/api';

import convertDateToBr from '../../../../utils/convertDateToBr';

import ListingTemplate from '../../../../components/Template/Listing';
import Button from '../../../../components/Button';
import Loading from '../../../../components/Loading';
import Tooltip from '../../../../components/Tooltip';

import { IPermission } from '../../../../interfaces/permission';
import { IProject } from '../../../../interfaces/project';
import convertInitToUppercase from '../../../../utils/convertInitToUppercase';

interface PermissionDTO {
  permissions: IPermission;
}

const ListPurchasingProjects: React.FC<PermissionDTO> = ({ permissions }) => {
  const { addToast } = useToast();
  const [loading, setLoading] = useState<boolean>(false);
  const [loadingFile, setLoadingFile] = useState<boolean>(false);
  const [buttonClicked, setButtonClicked] = useState<string>('');
  const [
    listProjectsWithPurchasingActive,
    setListProjectsWithPurchasingActive,
  ] = useState<IProject[]>([]);
  const [
    listProjectsWithPurchasingActivePaginated,
    setListProjectsWithPurchasingActivePaginated,
  ] = useState<IProject[]>([]);

  useEffect(() => {
    const getProvider = async (): Promise<void> => {
      try {
        setLoading(true);

        const response: any = await api.get(`purchasing/active`);

        if (response.data.length > 0) {
          const responseOrdered = response.data.map((i: IProject) => ({
            ...i,
            createdAt: i.createdAt,
            updatedAt: i.updatedAt,
          }));
          setListProjectsWithPurchasingActive(responseOrdered);
          setListProjectsWithPurchasingActivePaginated(responseOrdered);
        }
        setLoading(false);
      } catch (error: any) {
        setLoading(false);

        if (error.response) {
          const { data } = error.response; // Error vindo do back está em data dentro de response
          addToast({
            type: 'error',
            title: data.message,
          });
          return;
        }

        addToast({
          type: 'error',
          title: 'Erro ao listar!',
          description: `Error: ${error}`,
        });
      }
    };
    getProvider();
  }, [addToast]);

  const handleOpenFile = useCallback(
    (fileName: string, nameButtonClicked: string) => {
      setLoadingFile(true);
      setButtonClicked(nameButtonClicked);

      const extensionFile = fileName.substring(fileName.lastIndexOf('.') + 1);

      let typeBlob = '';

      switch (extensionFile) {
        case 'pdf':
          typeBlob = `application/${extensionFile}`;
          break;
        case 'tiff':
          typeBlob = `image/${extensionFile}`;
          break;
        default:
          typeBlob = `image/${extensionFile}`;
      }

      api
        .get(`drawings/file/${fileName}`, {
          responseType: 'arraybuffer',
        })
        .then((response: any) => {
          const url = window.URL.createObjectURL(
            new Blob([response.data], { type: typeBlob }),
          );

          window.open(url);
          setLoadingFile(false);
          setButtonClicked('');
        })
        .catch(error => {
          setLoadingFile(false);
          setButtonClicked('');

          if (error.response.data) {
            const { data } = error.response; // Error vindo do back está em data dentro de response
            addToast({
              type: 'error',
              title: data.message,
            });
            return;
          }

          addToast({
            type: 'error',
            title: 'Erro ao Exibir!',
            description: `Error: ${error}`,
          });
        });
    },
    [addToast],
  );

  const handleListProjectsWithPurchasingActivePaginatedItems = useCallback(
    newList => {
      setListProjectsWithPurchasingActivePaginated(newList);
    },
    [],
  );

  return (
    <ListingTemplate
      title="Compras"
      module="purchasing"
      listItemsProps={listProjectsWithPurchasingActive}
      handleListItemsPaginatedItems={
        handleListProjectsWithPurchasingActivePaginatedItems
      }
      displaySearchArea={false}
      displayButtonNew={false}
      disabled={loading}
      permissions={permissions}
      perPageForPaginationProp={30}
    >
      <Container>
        <Content>
          {loading ? (
            <p>carregando ...</p>
          ) : (
            <table>
              <thead>
                <tr>
                  <th>Nº</th>
                  <th>Cliente</th>
                  <th>Descrição</th>
                  <th>Quant.</th>
                  <th>Desenho</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {listProjectsWithPurchasingActivePaginated.map(
                  (purchasingItem: IProject, index) => (
                    <tr key={String(purchasingItem.id)}>
                      <td>{purchasingItem.id}</td>
                      <td>
                        {convertInitToUppercase(purchasingItem.client.name)}
                      </td>
                      <td>{purchasingItem.description}</td>
                      <td>{purchasingItem.quantity}</td>
                      <td>
                        {purchasingItem.drawings.map((item: any) => (
                          <ContainerInfoDrawing key={String(item.id)}>
                            <Tooltip
                              style={{
                                textTransform: 'capitalize',
                              }}
                              colorBefore="var(--azul-5bits)"
                              colorSpan="var(--azul-5bits)"
                              title={`Rev.: ${
                                item.revisionNumber
                              } | Rev. Date: ${convertDateToBr(
                                item.revisionDate,
                              )}`}
                            >
                              <InfoDrawing>
                                <div>
                                  <span>
                                    {convertInitToUppercase(item.drawingName)}
                                  </span>
                                  <span>{item.drawingNumber}</span>
                                </div>
                                {(loadingFile &&
                                  buttonClicked === `openFile${index}` && (
                                    <Button
                                      name="buttonSpinner"
                                      type="button"
                                      onClick={e => {
                                        e.preventDefault();
                                      }}
                                    >
                                      <Loading size={24} color="white" />
                                    </Button>
                                  )) || (
                                  <Button
                                    name={`openFile${index}`}
                                    type="button"
                                    onClick={e => {
                                      e.preventDefault();
                                      handleOpenFile(
                                        item.fileName,
                                        `openFile${index}`,
                                      );
                                    }}
                                  >
                                    Exibir
                                  </Button>
                                )}
                              </InfoDrawing>
                            </Tooltip>
                          </ContainerInfoDrawing>
                        ))}
                      </td>
                      <td>
                        {(purchasingItem.projectHasServices &&
                          purchasingItem.projectHasServices.length > 0 && (
                            <>
                              {(permissions.update && (
                                <Link
                                  to={`/purchasing/update/${purchasingItem.id}`}
                                >
                                  <FiEdit size={16} color="var(--azul-5bits)" />
                                </Link>
                              )) || (
                                <FiEdit
                                  size={16}
                                  color="var(--cinza-escuro-5bits)"
                                />
                              )}
                            </>
                          )) || (
                          <>
                            {(permissions.create && (
                              <Link
                                to={`/purchasing/update/${purchasingItem.id}`}
                              >
                                <AiOutlineFileAdd
                                  size={16}
                                  color="var(--azul-5bits)"
                                />
                              </Link>
                            )) || (
                              <AiOutlineFileAdd
                                size={16}
                                color="var(--cinza-escuro-5bits)"
                              />
                            )}
                          </>
                        )}
                      </td>
                    </tr>
                  ),
                )}
              </tbody>
            </table>
          )}
        </Content>
      </Container>
    </ListingTemplate>
  );
};

export default ListPurchasingProjects;
